import React, { useState, useEffect, useContext, memo } from "react";

import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import validatesNotNull from "../../utils/validatesNotNull";
import api from "../../services/api";
import ModalLoading from "../../components/modalLoading/ModalLoading";
import { GlobalVariables } from "../../global";
import { UserContext } from "../../context/UserContext";
import { notify } from "../../utils/notify";
import MaskService from "../../utils/mask/maskService";
import { formatDateAmerican } from "../../utils/formatDate";
import TextFieldCustom from "../../components/basic/TextFieldCustom";
import "./.promocode.css";

const Products = ({
  cnpj,
  fantasy,
  email,
  setUsersPromoter,
  usersPromoter,
  setPromoters,
  promoters,
  optionsPromoters,
  optionsUsers,
}) => {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([
    {
      Id: 0,
      IdFamilia: 0,
      IdProduto: 0,
      IdVersao: 0,
      Rota: "",
      IdTipoPromotor: 0,
      PromotorCNPJ: "",
      IdUsuario: 0,
      DataExpiracao: "",
      DataContrato: "",
      DataCancelamento: "",
      DataBloqueio: "",
      DataConsultaLimite: "",
      Demo: false,
      Trial: false,
      Freemium: false,
      ValoresParametros: {},
      IdMotivoCancelamento: 0,
    },
  ]);

  const [optionsFamily, setOptionsFamily] = useState([
    { Id: 0, Descricao: "" },
  ]);
  const [optionsProducts, setOptionsProducts] = useState([
    { Id: 0, Descricao: "" },
  ]);
  const [optionsVersions, setOptionsVersions] = useState([
    { Id: 0, Descricao: "", IdTipoPromotorAcesso: "" },
  ]);
  const [optionsCancellation, setOptionsCancellation] = useState([
    { Id: 0, Descricao: "" },
  ]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true);

        const cnpjRemoveMask = cnpj;

        const { data } = await api.get(
          `mapa/dadosProdutos/cliente/${cnpjRemoveMask.replace(/[^0-9]+/g, "")}`
        );

        data.cancellationReasons.unshift({ Id: 0, Descricao: "" });
        data.families.unshift({ Id: 0, Descricao: "" });
        data.products.unshift({ Id: 0, Descricao: "" });
        data.versions.unshift({
          Id: 0,
          Descricao: "",
          IdTipoPromotorAcesso: "",
        });

        data.maps.push({
          Id: 0,
          IdFamilia: 0,
          IdProduto: 0,
          IdVersao: 0,
          Rota: "",
          IdTipoPromotor: 0,
          PromotorCNPJ: "",
          IdUsuario: 0,
          DataExpiracao: "",
          DataContrato: "",
          DataCancelamento: "",
          DataBloqueio: "",
          DataConsultaLimite: "",
          Demo: false,
          Trial: false,
          Freemium: false,
          ValoresParametros: {},
          IdMotivoCancelamento: 0,
        });

        data.users.unshift({ Id: 0, Nome: "", PromotorCNPJ: "" });
        data.promoters.unshift({ CNPJ: "", IdTipoPromotor: 0, Fantasia: "" });
        data.typePromoters.unshift({ Id: 0, Nome: "" });

        setOptionsCancellation(data.cancellationReasons);
        setOptionsFamily(data.families);
        setOptionsProducts(data.products);
        setOptionsVersions(data.versions);
        setProducts(data.maps);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(error);
        notify("Não foi possível obter os produtos deste cliente.");
      }
    };
    getData();
  }, [cnpj, user.IdTipoPromotor]);

  const addProduct = async (generateBase) => {
    try {
      setLoading(true);
      const addNewProduct = [...products];

      const lastProduct = addNewProduct[products.length - 1];

      const required = [
        { value: lastProduct.DataContrato, key: "DataContrato" },
        { value: lastProduct.IdFamilia, key: "IdFamilia" },
        { value: lastProduct.IdProduto, key: "IdProduto" },
        { value: lastProduct.IdVersao, key: "IdVersao" },
      ];

      if (
        lastProduct.IdVersao !== GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL
      ) {
        required.push({ value: lastProduct.Rota, key: "Rota" });

        if (lastProduct.Trial) {
          required.push({
            value: lastProduct.DataExpiracao,
            key: "DataExpiracao",
          });
        }
      }

      let validationFail = false;

      let resultValidation = validatesNotNull(required);

      if (user.IdTipoUsuario !== GlobalVariables.ADM_QYON) {
        lastProduct.IdTipoPromotor = user.IdTipoPromotor;
        lastProduct.PromotorCNPJ = user.PromotorCNPJ;
        lastProduct.IdUsuario = user.Id;
      }

      if (
        lastProduct.Trial &&
        (Object.prototype.toString.call(new Date(lastProduct.DataExpiracao)) !==
          "[object Date]" ||
          isNaN(new Date(lastProduct.DataExpiracao).getTime()))
      ) {
        notify("A data de expiração informada é inválida.");
        validationFail = true;
        resultValidation.errorsValidation.DataExpiracao = true;
      }

      if (
        Object.prototype.toString.call(new Date(lastProduct.DataContrato)) !==
          "[object Date]" ||
        isNaN(new Date(lastProduct.DataContrato).getTime())
      ) {
        notify("A data do contrato informada é inválida.");
        validationFail = true;
        resultValidation.errorsValidation.DataContrato = true;
      } else if (
        Date.parse(lastProduct.DataContrato) > Date.parse(new Date())
      ) {
        notify("A data do contrato não pode ser futura.");
        validationFail = true;
        resultValidation.errorsValidation.DataContrato = true;
      }

      if (lastProduct.Rota && lastProduct.Rota.length < 2) {
        notify("O nome de acesso deve conter no mínimo 2 caracteres.");
        validationFail = true;
        resultValidation.errorsValidation.Rota = true;
      }

      if (resultValidation.error || validationFail) {
        setErrors({
          ...resultValidation.errorsValidation,
          index: products.length - 1,
        });
        return setLoading(false);
      } else {
        setErrors({});
      }

      const cnpjRemoveMask = cnpj;

      const result = await api.post("mapa", {
        IdTipoUsuarioLogin: parseInt(user.IdTipoUsuario),
        Data: new Date(),
        IdTipoPromotor: lastProduct.IdTipoPromotor
          ? parseInt(lastProduct.IdTipoPromotor)
          : null,
        PromotorCNPJ: lastProduct.PromotorCNPJ || null,
        IdUsuario: lastProduct.IdUsuario
          ? parseInt(lastProduct.IdUsuario)
          : null,
        IdFamilia: parseInt(lastProduct.IdFamilia),
        IdProduto: parseInt(lastProduct.IdProduto),
        IdVersao: parseInt(lastProduct.IdVersao),
        Rota: lastProduct.Rota,
        ClienteCNPJ: cnpjRemoveMask.replace(/[^0-9]+/g, ""),
        Fantasia: fantasy,
        Email: email,
        ValoresParametros: lastProduct.ValoresParametros,
        Demo: lastProduct.Demo,
        Trial: lastProduct.Trial,
        Freemium: lastProduct.Freemium,
        DataExpiracao: lastProduct.Trial ? lastProduct.DataExpiracao : null,
        DataContrato: lastProduct.DataContrato,
        GenerateBase: generateBase,
      });

      if (result) {
        addNewProduct[products.length - 1].Id = result.data.data.IdMapa;
        addNewProduct[products.length - 1].IdTipoPromotor =
          lastProduct.IdTipoPromotor;
        addNewProduct[products.length - 1].PromotorCNPJ =
          lastProduct.PromotorCNPJ;
        addNewProduct[products.length - 1].IdUsuario = lastProduct.IdUsuario;
        addNewProduct[products.length - 1].New = true;

        addNewProduct.push({
          IdFamilia: 0,
          IdProduto: 0,
          IdVersao: 0,
          Rota: "",
          DataExpiracao: "",
          DataContrato: "",
          DataCancelamento: "",
          DataBloqueio: "",
          DataConsultaLimite: "",
          Demo: false,
          Trial: false,
          Freemium: false,
          ValoresParametros: {},
          IdMotivoCancelamento: 0,
        });

        if (
          user.IdTipoPromotor !== GlobalVariables.ADM_QYON &&
          lastProduct.IdTipoPromotor
        ) {
          const copyPromoters = { ...promoters };
          const copyUsersPromoter = { ...usersPromoter };
          const columnsPromocode =
            GlobalVariables.TIPO_PROMOTOR[lastProduct.IdTipoPromotor];

          copyPromoters[columnsPromocode.Promoter] =
            optionsPromoters.find(
              (promt) => promt.CNPJ === lastProduct.PromotorCNPJ
            ) || null;

          copyUsersPromoter[columnsPromocode.User] =
            optionsUsers.find(
              (usr) => usr.Id === parseInt(lastProduct.IdUsuario)
            ) || null;

          setPromoters(copyPromoters);
          setUsersPromoter(copyUsersPromoter);
        }

        setProducts(addNewProduct);
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      notify("Não foi possível adicionar o produto.");
      setLoading(false);
    }
  };

  const editProduct = async (index) => {
    try {
      setLoading(true);

      const copyProducts = [...products];

      const currentProduct = copyProducts[index];

      const required = [
        { value: currentProduct.DataContrato, key: "DataContrato" },
        { value: currentProduct.IdFamilia, key: "IdFamilia" },
        { value: currentProduct.IdProduto, key: "IdProduto" },
        { value: currentProduct.IdVersao, key: "IdVersao" },
      ];

      if (
        currentProduct.IdVersao !== GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL
      ) {
        required.push({ value: currentProduct.Rota, key: "Rota" });

        if (currentProduct.Trial === "S") {
          required.push({
            value: currentProduct.DataExpiracao,
            key: "DataExpiracao",
          });
        }
      }

      if (currentProduct.IdMotivoCancelamento) {
        required.push(
          {
            value: currentProduct.DataCancelamento,
            key: "DataCancelamento",
          },
          {
            value: currentProduct.DataBloqueio,
            key: "DataBloqueio",
          },
          {
            value: currentProduct.DataConsultaLimite,
            key: "DataConsultaLimite",
          }
        );
      }

      let validationFail = false;

      let resultValidation = validatesNotNull(required);

      if (
        currentProduct.Trial &&
        (Object.prototype.toString.call(
          new Date(currentProduct.DataExpiracao)
        ) !== "[object Date]" ||
          isNaN(new Date(currentProduct.DataExpiracao).getTime()))
      ) {
        notify("A data de expiração informada é inválida.");
        validationFail = true;
        resultValidation.errorsValidation.DataExpiracao = true;
      }

      if (
        Object.prototype.toString.call(
          new Date(currentProduct.DataContrato)
        ) !== "[object Date]" ||
        isNaN(new Date(currentProduct.DataContrato).getTime())
      ) {
        notify("A data do contrato informada é inválida.");
        validationFail = true;
        resultValidation.errorsValidation.DataContrato = true;
      } else if (
        Date.parse(currentProduct.DataContrato) > Date.parse(new Date())
      ) {
        notify("A data do contrato não pode ser futura.");
        validationFail = true;
        resultValidation.errorsValidation.DataContrato = true;
      }

      if (currentProduct.IdMotivoCancelamento) {
        if (
          Object.prototype.toString.call(
            new Date(currentProduct.DataCancelamento)
          ) !== "[object Date]" ||
          isNaN(new Date(currentProduct.DataCancelamento).getTime())
        ) {
          notify("A data do cancelamento informada é inválida.");
          validationFail = true;
          resultValidation.errorsValidation.DataCancelamento = true;
        } else if (
          Date.parse(currentProduct.DataCancelamento) > Date.parse(new Date())
        ) {
          notify("A data do cancelamento não pode ser futura.");
          validationFail = true;
          resultValidation.errorsValidation.DataCancelamento = true;
        }

        if (
          Object.prototype.toString.call(
            new Date(currentProduct.DataBloqueio)
          ) !== "[object Date]" ||
          isNaN(new Date(currentProduct.DataBloqueio).getTime())
        ) {
          notify("A data do bloqueio informada é inválida.");
          validationFail = true;
          resultValidation.errorsValidation.DataBloqueio = true;
        }

        if (
          Object.prototype.toString.call(
            new Date(currentProduct.DataConsultaLimite)
          ) !== "[object Date]" ||
          isNaN(new Date(currentProduct.DataConsultaLimite).getTime())
        ) {
          notify("A data de limite de consulta informada é inválida.");
          validationFail = true;
          resultValidation.errorsValidation.DataConsultaLimite = true;
        }
      }

      if (currentProduct.Rota && currentProduct.Rota.length < 2) {
        notify("O nome de acesso deve conter no mínimo 2 caracteres.");
        validationFail = true;
        resultValidation.errorsValidation.Rota = true;
      }

      if (resultValidation.error || validationFail) {
        setErrors({ ...resultValidation.errorsValidation, index });
        return setLoading(false);
      } else {
        setErrors({});
      }

      const cnpjRemoveMask = cnpj;

      const { data } = await api.put(`mapa/${currentProduct.Id}`, {
        IdMotivoCancelamento: currentProduct.IdMotivoCancelamento || null,
        DataCancelamento: currentProduct.IdMotivoCancelamento
          ? currentProduct.DataCancelamento
          : null,
        DataBloqueio: currentProduct.IdMotivoCancelamento
          ? currentProduct.DataBloqueio
          : null,
        DataConsultaLimite: currentProduct.IdMotivoCancelamento
          ? currentProduct.DataConsultaLimite
          : null,

        IdFamilia: currentProduct.IdFamilia,
        IdProduto: currentProduct.IdProduto,
        IdVersao: currentProduct.IdVersao,
        Rota: currentProduct.Rota,
        ClienteCNPJ: cnpjRemoveMask.replace(/[^0-9]+/g, ""),
        ValoresParametros: currentProduct.ValoresParametros,
        Demo: currentProduct.Demo,
        Trial: currentProduct.Trial,
        Freemium: currentProduct.Freemium,
        DataExpiracao: currentProduct.DataExpiracao,
        DataContrato: currentProduct.DataContrato,
      });

      if (data.success && data.data) {
        currentProduct.ValoresParametros = data.data.ValoresParametros;
        copyProducts[index] = currentProduct;
        setProducts(copyProducts);
        notify(data.msg, true, "info");
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <ModalLoading loading={loading} />}

      <Grid>
        <hr className="borderLineTop" />

        <label className="title">Produtos</label>

        {products &&
          products.map((item, index) => {
            let paramsCurrent = [];
            if (item.IdVersao) {
              const currentVersion = optionsVersions.find(
                (e) => e.Id === item.IdVersao
              );

              if (currentVersion && currentVersion.Parametros) {
                try {
                  const jsonVol = JSON.parse(currentVersion.Parametros);
                  paramsCurrent = jsonVol.params;
                } catch (error) {
                  item.IdVersao = 0;
                  notify("Não foi possível exibir parâmetros do produto.");
                }
              }
            }
            const isLastItem = index === products.length - 1;
            return (
              <Grid
                className="cardProduct"
                key={index}
                container
                alignItems="center"
                justify="center"
              >
                <Grid
                  item
                  container
                  alignItems="center"
                  justify="center"
                  spacing={2}
                  xs={11}
                >
                  {index !== products.length - 1 && (
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                      <TextField
                        style={{ width: "100%" }}
                        select
                        label="Motivo Cancelamento"
                        value={item.IdMotivoCancelamento || ""}
                        error={
                          index === errors.index && errors.IdMotivoCancelamento
                        }
                        onChange={(e) => {
                          const copyProducts = [...products];
                          const copyItem = { ...item };

                          copyItem.IdMotivoCancelamento = e.target.value;

                          copyProducts[index] = copyItem;
                          setProducts(copyProducts);
                        }}
                      >
                        {optionsCancellation.map((option) => (
                          <MenuItem key={option.Id} value={option.Id}>
                            {option.Descricao}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  )}

                  {((index !== products.length - 1 &&
                    item.IdMotivoCancelamento) ||
                    false) && (
                    <>
                      <Grid item lg={3} md={4} sm={6} xs={12}>
                        <TextFieldCustom
                          style={{ width: "100%" }}
                          label="Data do Cancelamento*"
                          type="date"
                          value={item.DataCancelamento || ""}
                          error={
                            index === errors.index && errors.DataCancelamento
                          }
                          onChange={(e) => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyItem.DataCancelamento = e.target.value;

                            copyProducts[index] = copyItem;
                            setProducts(copyProducts);
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                      <Grid item lg={3} md={4} sm={6} xs={12}>
                        <TextFieldCustom
                          style={{ width: "100%" }}
                          label="Data Bloqueio da Base*"
                          type="date"
                          value={item.DataBloqueio || ""}
                          error={index === errors.index && errors.DataBloqueio}
                          onChange={(e) => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyItem.DataBloqueio = e.target.value;

                            copyProducts[index] = copyItem;
                            setProducts(copyProducts);
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>

                      <Grid item lg={3} md={4} sm={6} xs={12}>
                        <TextFieldCustom
                          style={{ width: "100%" }}
                          label="Data Limite de Consulta*"
                          type="date"
                          value={item.DataConsultaLimite || ""}
                          error={
                            index === errors.index && errors.DataConsultaLimite
                          }
                          onChange={(e) => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyItem.DataConsultaLimite = e.target.value;

                            copyProducts[index] = copyItem;
                            setProducts(copyProducts);
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    </>
                  )}

                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <TextFieldCustom
                      style={{ width: "100%" }}
                      label="Data do Contrato*"
                      type="date"
                      value={item.DataContrato || ""}
                      error={index === errors.index && errors.DataContrato}
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.DataContrato = e.target.value;

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>

                  <Grid item lg={3} md={6} sm={6} xs={12}>
                    <TextField
                      style={{ width: "100%" }}
                      select
                      disabled={index !== products.length - 1}
                      label="Família*"
                      value={item.IdFamilia}
                      error={index === errors.index && errors.IdFamilia}
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.IdFamilia = e.target.value;
                        copyItem.IdProduto = 0;
                        copyItem.IdVersao = 0;
                        copyItem.Rota = "";

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                    >
                      {optionsFamily.map((option) => (
                        <MenuItem key={option.Id} value={option.Id}>
                          {option.Descricao}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <TextField
                      style={{ width: "100%" }}
                      disabled={index !== products.length - 1}
                      select
                      label="Produto*"
                      value={item.IdProduto}
                      error={index === errors.index && errors.IdProduto}
                      onChange={(e) => {
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.IdProduto = e.target.value;
                        copyItem.IdVersao = 0;
                        copyItem.Rota = "";

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                    >
                      {optionsProducts.map((option) => {
                        if (
                          option.Id === 0 ||
                          (item.IdFamilia &&
                            option.IdFamilia === item.IdFamilia)
                        ) {
                          return (
                            <MenuItem key={option.Id} value={option.Id}>
                              {option.Descricao}
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </TextField>
                  </Grid>

                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <TextField
                      style={{ width: "100%" }}
                      className="textFieldPromocode"
                      disabled={index !== products.length - 1}
                      select
                      label="Versão*"
                      value={item.IdVersao}
                      error={index === errors.index && errors.IdVersao}
                      onChange={(e) => {
                        const versionSelect = optionsVersions.find(
                          (v) => v.Id === e.target.value
                        );
                        const copyProducts = [...products];
                        const copyItem = { ...item };

                        copyItem.IdVersao = e.target.value;
                        if (versionSelect && versionSelect.ValoresPadrao) {
                          try {
                            copyItem.ValoresParametros = JSON.parse(
                              versionSelect.ValoresPadrao
                            );
                          } catch (error) {
                            copyItem.ValoresParametros = {};
                            item.IdVersao = 0;
                            notify(
                              "Não foi possível exibir parâmetros do produto."
                            );
                          }
                        } else {
                          copyItem.ValoresParametros = {};
                        }

                        copyItem.Trial = true;
                        copyItem.Freemium = false;

                        const dateExpiration = new Date();
                        if (
                          versionSelect &&
                          (versionSelect.DiasTrial ||
                            versionSelect.DiasTrial === 0)
                        ) {
                          dateExpiration.setDate(
                            dateExpiration.getDate() + versionSelect.DiasTrial
                          );
                          copyItem.DataExpiracao =
                            formatDateAmerican(dateExpiration);
                        }

                        copyItem.Rota = "";

                        copyProducts[index] = copyItem;
                        setProducts(copyProducts);
                      }}
                    >
                      {optionsVersions.map((option) => {
                        if (
                          option.Id === 0 ||
                          ((index !== products.length - 1 ||
                            option.IdTipoPromotorAcesso) &&
                            item.IdProduto &&
                            option.IdProduto === item.IdProduto)
                        ) {
                          return (
                            <MenuItem key={option.Id} value={option.Id}>
                              {option.Descricao}
                            </MenuItem>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </TextField>
                  </Grid>

                  {item.IdVersao !==
                    GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL && !isLastItem && (
                    <Grid item lg={3} md={4} sm={12} xs={12}>
                      <TextFieldCustom
                        label="Nome de Acesso*"
                        type="text"
                        disabled={!isLastItem}
                        value={item.Rota}
                        error={index === errors.index && errors.Rota}
                        onChange={(e) => {
                          const copyProducts = [...products];
                          const copyItem = { ...item };

                          copyItem.Rota = e.target.value
                            .normalize("NFD")
                            .toLowerCase()
                            .replace(/[^a-z0-9_]/g, "")
                            .substring(0, 20);

                          copyProducts[index] = copyItem;
                          setProducts(copyProducts);
                        }}
                      />
                    </Grid>
                  )}

                  {item.IdVersao !==
                    GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL && (
                    <Grid item lg={2} md={2} sm={2} xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={item.Demo}
                            onChange={() => {
                              const copyProducts = [...products];
                              const copyItem = { ...item };

                              copyItem.Demo = item.Demo ? false : true;

                              copyProducts[index] = copyItem;
                              setProducts(copyProducts);
                            }}
                            name="demo"
                            className="checkboxColor"
                          />
                        }
                        label="Demo"
                      />
                    </Grid>
                  )}

                  {item.IdVersao !==
                    GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL && (
                    <Grid item lg={2} md={2} sm={2} xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={
                              user.IdTipoUsuario !== GlobalVariables.ADM_QYON
                            }
                            checked={item.Freemium}
                            onChange={() => {
                              const copyProducts = [...products];
                              const copyItem = { ...item };

                              copyItem.Freemium = item.Freemium ? false : true;

                              if (copyItem.Freemium) copyItem.Trial = false;

                              copyProducts[index] = copyItem;
                              setProducts(copyProducts);
                            }}
                            name="checkedB"
                            className="checkboxColor"
                          />
                        }
                        label="Freemium"
                      />
                    </Grid>
                  )}

                  {item.IdVersao !==
                    GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL && (
                    <Grid item lg={2} md={2} sm={2} xs={3}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={
                              user.IdTipoUsuario !== GlobalVariables.ADM_QYON
                            }
                            checked={item.Trial && item.Trial !== "N"}
                            onChange={() => {
                              const copyProducts = [...products];
                              const copyItem = { ...item };

                              copyItem.Trial = item.Trial ? false : true;

                              if (copyItem.Trial) copyItem.Freemium = false;

                              copyProducts[index] = copyItem;
                              setProducts(copyProducts);
                            }}
                            name="checkedB"
                            className="checkboxColor"
                          />
                        }
                        label="Trial"
                      />
                    </Grid>
                  )}

                  {item.Trial &&
                    item.IdVersao !==
                      GlobalVariables.ID_VERSAO_ERP_PRO_ADICIONAL && (
                      <Grid item lg={3} md={4} sm={6} xs={7}>
                        <TextFieldCustom
                          style={{ width: "100%" }}
                          label="Data Expiração Trial*"
                          type="date"
                          disabled={
                            user.IdTipoUsuario !== GlobalVariables.ADM_QYON
                          }
                          value={item.DataExpiracao || ""}
                          error={index === errors.index && errors.DataExpiracao}
                          onChange={(e) => {
                            const copyProducts = [...products];
                            const copyItem = { ...item };

                            copyItem.DataExpiracao = e.target.value;

                            copyProducts[index] = copyItem;
                            setProducts(copyProducts);
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    )}

                  {paramsCurrent.map((element, indexParams) => {
                    if (element.isFlag) {
                      return (
                        <Grid
                          item
                          lg={3}
                          md={4}
                          sm={12}
                          xs={12}
                          key={indexParams}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled={
                                  user.IdTipoUsuario !==
                                    GlobalVariables.ADM_QYON && element.default
                                    ? true
                                    : false
                                }
                                checked={
                                  item?.ValoresParametros?.[element.key] ||
                                  false
                                }
                                onChange={() => {
                                  const copyItem = { ...item };
                                  const copyProducts = [...products];
                                  copyItem.ValoresParametros[element.key] =
                                    copyItem.ValoresParametros[element.key]
                                      ? false
                                      : true;
                                  copyProducts[index] = copyItem;
                                  setProducts(copyProducts);
                                }}
                                name="checkedB"
                                className="checkboxColor"
                              />
                            }
                            label={element.label}
                          />
                        </Grid>
                      );
                    }

                    return (
                      <Grid
                        item
                        lg={3}
                        md={4}
                        sm={12}
                        xs={12}
                        key={indexParams}
                      >
                        <TextFieldCustom
                          label={element.label}
                          type={element.type ? element.type : "text"}
                          disabled={
                            user.IdTipoUsuario !== GlobalVariables.ADM_QYON &&
                            element.default
                              ? true
                              : false
                          }
                          value={
                            element?.mask
                              ? MaskService.toMask(
                                  element?.mask,
                                  item?.ValoresParametros?.[element.key] || ""
                                )
                              : item?.ValoresParametros?.[element.key] || ""
                          }
                          onChange={(e) => {
                            const copyItem = { ...item };
                            const copyProducts = [...products];

                            if (element.mask) {
                              copyItem.ValoresParametros[element.key] =
                                MaskService.toMask(
                                  element.mask,
                                  e.target.value
                                );
                            } else {
                              copyItem.ValoresParametros[element.key] =
                                e.target.value;
                            }

                            copyProducts[index] = copyItem;
                            setProducts(copyProducts);
                          }}
                        />
                      </Grid>
                    );
                  })}
                </Grid>

                <Grid
                  item
                  xs={12}
                  container
                  alignItems="center"
                  justify="center"
                >
                  {index === products.length - 1 ? (
                    <Grid item container justify="center" spacing={5}>
                      <Grid item flex>
                        <button
                          id="buttonStylePromocode"
                          type="button"
                          className="btn btn-info"
                          onClick={() => addProduct(true)}
                        >
                          Gerar Produto
                        </button>
                      </Grid>
                      <Grid item flex>
                        <button
                          id="buttonStylePromocodeLink"
                          type="button"
                          className="btn btn-info"
                          onClick={() => addProduct(false)}
                        >
                          Vincular Produto
                        </button>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid item lg={4} md={4} sm={6} xs={9}>
                      <button
                        id="buttonUpdateProduct"
                        type="button"
                        className="btn btn-info"
                        onClick={() => editProduct(index)}
                      >
                        Atualizar Produto
                      </button>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </>
  );
};

export default memo(Products);
